import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { sendEmailLink } from 'state/modules/user/thunks';
import { FONT_GSS_FUTURA, FONT_GSS_PRINT_WIDE } from 'themes/default';
import BasicButton from '../../@common/Buttons/BasicButton';
import { remCalc } from '../../../util/style-util';
import { activeGreen, errorRed, lightGray, white } from '../../../styles/style-constants';
import hittDevices from '../../../assets/images/hitt-devices-with-callout.png';
import hwtLogo from '../../../assets/images/hwt-logo-black.png';

const OptimalExperiencePage = () => {
  const [isEmailSent, setIsEmailSent] = useState<boolean>(false);

  const handleSubmit = async (event: Event | any) => {
    event.preventDefault();
    try {
      sendEmailLink();
      setIsEmailSent(true);
    } catch (err) {
      setIsEmailSent(false);
    }
  };

  const {
    container,
    containerBody,
    devices,
    emailForm,
    statusMessage,
    successMessage,
    button,
    footerContainer,
    footer,
    heading1,
    heading3
  } = useStyles();

  return (
    <div className={container}>
      <div className={containerBody}>
        <h1 className={heading1}>
          The Interactive Digital Teaching Tool (IDTT) works best on large screens.
        </h1>
        <img className={devices} src={hittDevices} alt="HITT Devices" />
        <h3 className={heading3}>
          We recommend using an Interactive Whiteboard or Desktop computer.
        </h3>
        {isEmailSent && <span className={clsx(statusMessage, successMessage)}>Link sent!</span>}
        <form className={emailForm} onSubmit={handleSubmit}>
          <BasicButton buttonStyles={[button]} type="submit">
            Email yourself a link
          </BasicButton>
        </form>
      </div>
      <footer className={footerContainer}>
        <img src={hwtLogo} className={footer} alt="Handwriting Without Tears" />
      </footer>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    backgroundColor: white,
    textAlign: 'center',
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderTop: `10px solid #F9E300`
  },
  containerBody: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: remCalc(20, 40, 20, 40)
  },
  heading1: {
    fontWeight: 700,
    fontSize: remCalc(30),
    padding: remCalc(0, 0, 10, 0),
    margin: 0,
    fontFace: FONT_GSS_FUTURA
  },
  heading3: {
    fontWeight: 300,
    fontSize: remCalc(20),
    padding: remCalc(10, 0),
    margin: 0,
    fontFace: FONT_GSS_PRINT_WIDE
  },
  devices: {
    maxWidth: 574,
    width: '80%'
  },
  statusMessage: {
    fontWeight: 400
  },
  errorMessage: {
    color: errorRed
  },
  successMessage: {
    color: activeGreen,
    padding: remCalc(10, 0, 20, 0)
  },
  emailForm: {
    fontWeight: 400,
    width: '100%'
  },
  buttonMenu: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    flexFlow: 'row wrap'
  },
  button: {
    margin: remCalc(10, 0, 10, 0),
    userSelect: 'none',
    border: '1px solid rgb(7,148,234)',
    backgroundColor: white,
    color: 'rgb(7,148,234)',
    width: '100%',
    fontWeight: '500 !important',
    cursor: 'pointer'
  },
  footerContainer: {
    backgroundColor: lightGray
  },
  footer: {
    padding: remCalc(10),
    maxWidth: '496px',
    width: '75%'
  }
}));

export default OptimalExperiencePage as any;
